import dayjs from 'dayjs';

export const getDatesForCalendar = (date: Date): Date[] => {
  if (isNaN(date.getTime())) {
    return [];
  }

  const d = dayjs(date);
  // Get boundaries for month
  const firstDate = d.date(1);

  // Get first date where weekday is 1 before first date
  const startDate = firstDate.day(1);

  const retVal: Date[] = [];
  for (let i = 0; i < 7 * 6; i++) {
    const current = startDate.add(i, 'day');
    retVal.push(current.toDate());
  }
  return retVal;
};
